<template>
  <v-container
    data-vue-component-name="Upload"
    class="justify-center align-center"
    fill-height
    fluid
  >
    <v-row justify="center">
      <v-col cols="3">
        <template v-if="isLoading">
          <v-row justify="center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            />
          </v-row>

          <v-row justify="center">
            <span class="message">
              Please wait while we upload your responses...
            </span>
          </v-row>
        </template>

        <template v-else>
          <v-row justify="center" class="text-center">
            {{ message }}
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Upload',
  data: () => ({
    isLoading: true,
    message: null,
  }),
  computed: {
    getUserEmail() {
      return this.$store.state.logs.user_info?.email;
    },
  },
  mounted() {
    this.$store.dispatch('requestSaveData', this.generateFileName())
      .then(() => {
        this.message = 'Nice job! You\'ve completed the tech fluency tasks.';
      })
      .catch((err) => {
        this.message = err.message;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    generateFileName() {
      return Date
        .now()
        .toString()
        .concat(this.getUserEmail)
        .concat('.json');
    },
  },
};
</script>

<style scoped lang="scss">
[data-vue-component-name="Upload"] {
  span.message {
    font-weight: 400;
    font-size: 16px;
    margin: 20px -8px 0 0;
    text-align: center;
  }
}
</style>
